module.exports = __webpack_public_path__ + "static/media/timeline-awaiting-approval.7eb5f15c.svg";